import styled from "styled-components";
import { Box } from "@mui/material";

export const PageContainer = styled(Box)`
  padding: 24px;
  min-height: calc(100vh - 64px);

  @media (max-width: 767px) {
    padding: 0px;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const PageTitle = styled.h1`
  font-size: 30px;
  font-weight: 400;
  color: #5a5a5a;
  margin: 0 0 24px 0;

  @media (max-width: 767px) {
    font-size: 24px;
    margin-bottom: 16px;
  }
`;

export const SearchAndActionBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SearchWrapper = styled.div`
  position: relative;
  flex: 1;
  max-width: 400px;

  @media (max-width: 767px) {
    max-width: 100%;
    margin-bottom: 16px;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 50px;
  padding: 12px 16px 12px 48px;
  border: 1px solid #e39435;
  border-radius: 6px;
  font-size: 14px;
  color: #2d3748;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border: 2px solid #76b041;
  }

  &:hover {
    border-color: #76b041;
  }

  &::placeholder {
    color: #b8b8b8;
  }
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropdownContainer = styled.div`
  position: relative;
`;

export const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: #76B041;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  height: 50px;
  min-width: 150px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #8fb56bff;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const DropdownMenu = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 180px;
  display: ${(props) => (props.$isOpen ? "block" : "none")};
`;

export const DropdownItem = styled.button`
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  text-align: left;
  font-size: 14px;
  color: #1E2F23;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #f7fafc;
  }

  &:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  &:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`;

export const TabsContainer = styled.div`
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 24px;
`;

export const TabsList = styled.div`
  display: flex;
  gap: 0;
`;

export const Tab = styled.button<{ $isActive: boolean }>`
  padding: 16px 24px;
  border: none;
  background: none;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => (props.$isActive ? "#e39435" : "#1E2F23")};
  cursor: pointer;
  border-bottom: 2px solid
    ${(props) => (props.$isActive ? "#e39435" : "transparent")};
  transition: all 0.2s;

  &:hover {
    color: #e39435;
    background: #fef5e7;
  }

  @media (max-width: 767px) {
    padding: 12px 16px;
    font-size: 14px;
  }
`;

export const TabContent = styled.div`
  min-height: 400px;
`;

export const CategorySection = styled.div`
  margin-bottom: 24px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
`;

export const CategoryHeader = styled.div<{ isExpanded: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: ${(props) => (props.isExpanded ? "#f7fafc" : "#ffffff")};
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #f7fafc;
  }
`;

export const CategoryTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CategoryName = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
`;

export const ChevronIcon = styled.div<{ $isExpanded: boolean }>`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* transform: ${(props) =>
    props.$isExpanded ? "rotate(90deg)" : "rotate(0deg)"}; */
  transition: transform 0.2s;
  color: white;
`;

export const EditCategoryLink = styled.button`
  color: #e39435;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background: #fef5e7;
    text-decoration: underline;
  }
`;

export const CategoryContent = styled.div<{ isExpanded: boolean }>`
  display: ${(props) => (props.isExpanded ? "block" : "none")};
  border-top: 1px solid #e2e8f0;
`;

export const ItemsList = styled.div`
  padding: 0;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.2s;

  &:hover {
    background: #f8fafc;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const ItemImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 16px;
`;

export const ItemDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ItemName = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
`;

export const ItemPrice = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #e39435;
`;

export const ItemOptionGroups = styled.div`
  font-size: 12px;
  color: #718096;
  margin-top: 4px;
`;

export const ItemActions = styled.div`
  display: flex;
  align-items: center;
`;

export const EditItemLink = styled.button`
  color: #e39435;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background: #fef5e7;
    text-decoration: underline;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #718096;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #4a5568;
  margin: 0 0 8px 0;
`;

export const EmptyStateDescription = styled.p`
  font-size: 14px;
  color: #718096;
  margin: 0;
`;
